import styled from "styled-components";

export const SelectPlanStyle = styled.div`
    height: 100vh;
    width: 100%;
    background-color: #E5F8FA;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    button{
        border: none;
        background-color: #FDCAC3;
        padding: 15px;
        width: 200px;
        border-radius: 30px;
        align-self: flex-end;
        margin-top: 50px;
        cursor: pointer;

        &:hover{
            background-color: #e0e0e0;
        }
    }
`

export const WrapContent = styled.div`
    width: 75%;
    height: 80%;
    display: flex;
    flex-direction: column;
`

export const HeaderRow = styled.div`
    display: flex;
    width: 40%;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    cursor: pointer;

    h1{
        color: #FF5742;
        font-size: 30px;
        font-weight: 600;
    }
`

export const Info = styled.p`
        color: #428EFF;
        font-size: 15px;
        margin-top: 5px;
        margin-bottom: 50px;
`

export const ListPlanCards = styled.div`
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    height: 450px;
    padding: 20px;
`

export const PlanCard = styled.div`
  width: 100%;
  min-height: 130px; 
  background-color: #F7F7F7;
  border-radius: 30px;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  position: relative; 
  cursor: pointer;
  flex-shrink: 0; 
  margin-top: 10px;

  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.2);
  }
`;